import { object, string, define, assert, enums, optional, boolean, union, empty } from 'superstruct'

const isDate = value => {
  return typeof value === 'string' && /^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}.[0-9]{3}Z$/.test(value)
}
const DateStruct = define('DateStruct', (value) => isDate(value))


const isCountry = value => {
  return typeof value === 'string' && /^[A-Z]{2}$/.test(value)
}

const isEmpty = value => value?.trim() === '';

const CountryStruct = define('CountryStruct', (value) => isCountry(value) || isEmpty(value))

const validate = (schema, data) => {
    return assert(JSON.parse(data), schema)
}

const BirthplaceStruct = object({
  city: optional(union([string(), empty(string())])),
  country: optional(union([CountryStruct, empty(string())])),
})

const User = object({
  firstName: optional(string()),
  lastName: optional(string()),
  hasChangedMaidenName: optional(boolean()),
  maidenName: optional(string()),
  postalCode: optional(string()),
  country: string(),
  city: optional(string()),
  houseNumber: optional(string()),
  streetName: optional(string()),
  birthdate: optional(DateStruct),
  gender: enums(['male', 'female']),
  nationality: optional(union([CountryStruct, empty(string())])),
  birthplace: optional(union([BirthplaceStruct, empty(string())])),
  province: optional(string()),
  phone: optional(string()),
})

const bankLoginData = object({
  user: User
})

const validateLoginData = (data) => {
  return validate(bankLoginData, data)
}

export {
  validateLoginData
}



// WEBPACK FOOTER //
// ./src/partners/verify/data.js